@if (range) {
  <ngx-slider
    class="custom-slider"
    [options]="range" [(value)]="minValue" [(highValue)]="maxValue"
  (userChangeEnd)="changed($event)"></ngx-slider>
}
